module.exports = __webpack_public_path__ + "img/cream.749030a5.png";